const normalizeLabel = (value) => (value ? value.replaceAll('_', ' ').toUpperCase() : '')

export const getFieldLabel = (availableModel, fieldName) => {
    const customField = (availableModel?.customTaskFields || []).find((field) => field.fieldName === fieldName)
    if (customField) {
        return customField.label
    }
    return normalizeLabel(fieldName)
}

export const buildGroupedFieldOptions = (availableModel) => {
    if (!availableModel) return []

    const directFields = (availableModel.availableModelFields || []).map((field) => ({
        label: normalizeLabel(field),
        value: field,
    }))
    const groups = [{ label: 'Direct Fields', options: directFields }]

    const relatedModelFields = availableModel.relatedModelFields
    if (relatedModelFields) {
        Object.entries(relatedModelFields).forEach(([relationName, info]) => {
            const relOptions = (info.fields || []).map((field) => ({
                label: `${relationName}.${field}`.replaceAll('_', ' ').toUpperCase(),
                value: `${relationName}.${field}`,
            }))
            groups.push({ label: `${info.model_name} (${relationName})`, options: relOptions })
        })
    }

    const customFieldOptions = (availableModel.customTaskFields || []).map((field) => ({
        label: field.label,
        value: field.fieldName,
    }))
    if (customFieldOptions.length) {
        groups.push({ label: 'Custom Columns', options: customFieldOptions })
    }

    return groups
}

export const buildWatchColumnOptions = (availableModel) => {
    if (!availableModel) return []

    const directFields = (availableModel.availableModelFields || []).map((field) => ({
        label: normalizeLabel(field),
        value: field,
    }))
    const customFields = (availableModel.customTaskFields || []).map((field) => ({
        label: field.label,
        value: field.fieldName,
    }))

    return [...directFields, ...customFields]
}

export const getEnumConditionValueOptions = (availableModel, fieldName) => {
    const customField = (availableModel?.customTaskFields || []).find((field) => field.fieldName === fieldName)
    if (!customField || customField.columnType !== 'ENUM') return []

    return (customField.allowedOptions || []).map((option) => ({
        label: option,
        value: option,
    }))
}
